import { Loader2 } from 'lucide-react';
import { fetchRevenueByMonth } from '../services/mongoService';

export default function ChartCard({ title, subtitle, loading, error, height = 280, children }) {
  return (
    <div className="rounded-2xl bg-white border border-slate-100 shadow-sm p-5">
      <div className="flex items-start justify-between mb-4">
        <div>
          <h3 className="text-sm font-semibold text-slate-700">{title}</h3>
          {subtitle && <p className="text-xs text-slate-400 mt-0.5">{subtitle}</p>}
        </div>
        {loading && <Loader2 className="h-4 w-4 text-indigo-400 animate-spin shrink-0" />}
      </div>

      {error ? (
        <div
          className="flex items-center justify-center text-xs text-red-400 rounded-xl bg-red-50 border border-red-100"
          style={{ height }}
        >
          Failed to load data
        </div>
      ) : loading && !children ? (
        <div
          className="flex items-center justify-center rounded-xl bg-slate-50"
          style={{ height }}
        >
          <div className="space-y-3 w-full px-4">
            {[80, 60, 90, 50, 75].map((w, i) => (
              <div key={i} className="flex items-center gap-3">
                <div className="h-2 rounded-full bg-slate-200 animate-pulse" style={{ width: `${w}%` }} />
              </div>
            ))}
          </div>
        </div>
      ) : (
        children
      )}
    </div>
  );
}
